// Hooks/usePatch.jsx
import { useState } from "react";
import { fetchWithAuth } from "../Utils/fetchWithAuth";

export default function usePatch() {
  const [loading, setLoading] = useState(false);
  const [error, setError]     = useState(null);
  const [responseData, setResponseData] = useState(null);

  const patchData = async (url, body = {}) => {
    setLoading(true);
    setError(null);
    setResponseData(null);
    try {
      const res = await fetchWithAuth(url, {
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
      });

      if (!res.ok) {
        let detail = "";
        try {
          const t = await res.text();
          // se è JSON, prova a estrarre "detail" o errori di campo
          try {
            const j = JSON.parse(t);
            detail = j.detail || JSON.stringify(j);
          } catch {
            detail = t;
          }
        } catch {}
        throw new Error(`PATCH ${res.status}: ${detail || res.statusText}`);
      }

      const json = await res.json().catch(() => null);
      setResponseData(json);
      return json;
    } catch (e) {
      setError(e);
      throw e;
    } finally {
      setLoading(false);
    }
  };

  return { patchData, loading, error, responseData };
}
